// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J-TO","newExpiryDate":"styles_newExpiryDate__18r1g","footer":"styles_footer__3VJVz"};